export const CheckboxGroupProps = (formik: any, name: string) => ({
  values: formik.values[name],
  setValues: formik.setFieldValue,
  setTouched: formik.getFieldHelpers(name).setTouched,
  error: formik.touched[name] ? formik.errors[name] : undefined,
})
